import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Ez egy iOS eszköz?
 * @param ua - UserAgent.
 */
export default function isIOS (ua: string): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return userAgentParser.isIOS(ua)
}
